<style scoped>
img {
  width:60%

}

</style>

<template>
  <v-stepper 
    v-model="step"  
    class="elevation-0" 
    alt-labels 
    style="max-width:100%;margin-right:1rem;overflow-y:scroll;height:100%;">
    <v-stepper-header >
      <v-stepper-step :complete="step>2" step="1">Get device EUI</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>1" step="2">Plug&Play scenario</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>3" step="3">Setup TTN</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>4" step="4">Create TTN LoRa device profile</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>5" step="5">Register device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step   step="6">Configure device</v-stepper-step>
      <v-divider></v-divider>

      

    </v-stepper-header>

    <v-stepper-items class="subheading text-xs-left">

      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;margin-top:1.5rem;z-index:10" @click="step++; step = (step==7)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;bottom:0;z-index:10" @click="step++; step = (step==7)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>

      <v-stepper-content step="1" >
        <v-card >
          <v-card-title style="background-color:#39a9dc">
            <h2 class="title white--text font-weight-light">Get device EUI</h2>
          </v-card-title>
          <v-container>
            <v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                  <b>a</b>. Flash FP-ATR-LORA1 firmware binary and connect device to the PC via USB
                  </v-flex>
                  <v-flex xs12>
                  <b>b</b>. Open serial terminal (e.g. TeraTerm) to inspect device log
                  </v-flex>
                  <v-flex xs12 style=";text-align:center">
                    <img
                      style="" 
                      src="@/assets/howto/serialportsetup.png" />
                  </v-flex>
                  <v-flex xs12>
                  <b>c</b>. Read and <b>get device EUI</b> (or alternatively, send <code>?devicejoinparam</code> command)
                  </v-flex>
                  <v-flex xs12 style=";text-align:center">
                    <img
                      style="" 
                      src="@/assets/howto/deviceeui.png" />
                  </v-flex>
                </v-layout>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="2" >
          <v-card-title style="background-color:#39a9dc">
            <h2 class="title white--text font-weight-light">Plug & Play Scenario</h2>
          </v-card-title>
          <v-container>
            <v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                  For a quick evaluation of LoRa device, skip to step <code>5</code> and use <code>ST_LoRa_TTN_Default</code> as device profile during device registration. No TTN account will be need. 
                  </v-flex>
                </v-layout>
            </v-layout>
          </v-container>
        </v-card>
        <v-btn 
          color="#39a9dc"
          @click="step = 3"
          outline>
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card>
          <v-card-title  style="background-color:#39a9dc">
            <v-icon
              dark
              size="42"
              class="mr-3"
            >
              mdi-magnify
            </v-icon>
            <h2 class="title white--text font-weight-light">Setup TTN</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <b>a</b>. Create an account on <a href="https://account.thethingsnetwork.org/users/login">TTN console web service</a>
              </v-flex>
              <v-flex xs12>
                <b>b</b>. Create an application and get the auto-generated <b>Application EUI</b>
              </v-flex>
                <v-flex xs12 style=";text-align:center" >
                  <img
                  style=" ;text-align:center" 
                  src="@/assets/howto/ttncreateapp3.png" />
                </v-flex>
                <v-flex xs12>
                  <b>c</b>. Create and get <b>TTN api-key</b> with all permissions
                </v-flex>
                <v-flex xs12 style=";text-align:center" >
                    <img
                    style=" ;text-align:center" 
                    src="@/assets/howto/ttncreateapikey.png" />
                  </v-flex>
                <v-flex xs12>
                  <b>d</b>. Get <b>region prefix of TTN handler</b> (e.g. in this case <b>eu</b>)
                </v-flex>
                <v-flex xs12 style=";text-align:center" >
                    <img
                    style=" ;text-align:center" 
                    src="@/assets/howto/ttnhandler.png" />
                  </v-flex>
                <v-flex xs12>
                  <b>e</b>. Create and get an <b>asset-tracking api-key</b> from this dashboard
                </v-flex>
                <v-flex xs12 style=";text-align:center" >
                    <img
                    style=" ;text-align:center" 
                    src="@/assets/howto/assettrackingapikey.png" />
                  </v-flex>
                <v-flex xs12>
                  <b>f</b>. Create application HTTP integration with 
                  <ul>
                    <li>URL: <a>https://{{http.host}}/{{http.basePath}}/data?nostd=true</a></li>
                    <li>Authorization: set <b>asset-tracking api-key</b> previously created </li>
                  </ul>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>


      <v-stepper-content step="4">
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">TTN LoRa device profile</h2>
          </v-card-title>
          <v-container>
            <v-layout  row wrap>
              <v-flex xs12>
                In order to simplify the device provisioning, create a TTN LoRa device profile form <a v-on:click="$emit('routing', {name:'settings'})">settings</a> view. Use parameters got previously:  
                TTN ISM region, application ID, Join EUI, TTN Api-key. <i>Note</i>: a default <b>application key</b> is already provided
              </v-flex>
              <v-flex xs12 style="text-align:center">
                <img style="" src="@/assets/howto/assettrackingttnloradeviceprofile.png" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="5">
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Register device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Register device with:
                  <ul>
                    <li>human-friendly label</li>
                    <li>device EUI</li>
                    <li>device profile (default or the previous one created)</li>
                  </ul>
                </v-flex>
                <v-flex xs12  style="text-align:center">
                  <img style="" src="@/assets/howto/registerloradevice.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="6">
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Configure device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 >
                Configure physical device via serial terminal by seting parameters previously got:
                <ul>
                    <li>
                      Set device eui (<code>!deviceeui-xxxxxxxxxxxxxxx</code> , replacing x characthers with device eui value)
                    </li>
                    <li>
                      Set join eui (<code>!joineui-xxxxxxxxxxxxxxx</code> , replacing x characthers with join eui value)
                    </li>
                    <li>
                      Set network key (<code>!ntwkkey-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</code> , replacing x characthers with network key value)
                    </li>
                    <li>
                      Set application key (<code>!appkey-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</code> , replacing x characthers with application key value)
                    </li>
                    <li>
                      Reset the system (<code>!sysreset</code>)
                    </li>
                </ul>

                <span style="color:red;margin-top:1rem"><b>Note:</b>use Join EUI, Application Key and Network Key got from selected <a v-on:click="$emit('routing', {name:'settings'})">device profile</a> </span>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      step: 0
    }
  }
}
</script>